<script setup>
import { onMounted, computed, watch } from 'vue'
import ProductInfo from '@/components/ProductInfo.vue'
import InvoiceUpload from '@/components/InvoiceUpload.vue'
import {useGlobalStore} from '@/store'
import CustomAlert from "@/components/CustomAlert.vue";

const maxCount = 10
const globalStore = useGlobalStore()
const stepOne = computed(() => {
  return globalStore.stepOne
})
const products = computed(() => {
  return globalStore.stepOne.products ? globalStore.stepOne.products : null
})
const dealerNames = computed(() => {
  return globalStore.stepOne.dealerNames ? globalStore.stepOne.dealerNames : null
})
const productsLength = computed(() => {
  return globalStore.stepOne.products ? globalStore.stepOne.products.length : 0
})
const filesLength = computed(() => {
  return globalStore.stepOne.files ? globalStore.stepOne.files : 0
})
const isHiddenSerialNumberErrorAlert = computed(() => {
  return globalStore.stepOne.hideSerialNumberErrorAlert
})

const generateId = () => '_' + Math.random().toString(36).slice(2, 11)

function addNewProductInfo (isInitial) {
  if (isInitial && productsLength.value === 0 || (!isInitial && productsLength.value && productsLength.value + 1 <= maxCount && globalStore.areAllProductsValid())) {
    const product = {
      id: generateId(),
      valid: false,
      serialNumber: '',
      buyDate: '',
      buyPrice: '',
      invoiceNr: '',
      dealer: '',
      searchedProductHit: {}
    }

    globalStore.pushToStepOneProducts(product)
  }
  else {
    globalStore.isErrorState = true
  }
}

function handleProductInfoDelete (id) {
  if (productsLength.value && productsLength.value - 1 >= 1) {
    globalStore.deleteStepOneProduct(id)
  }
}

function closeAlert() {
  globalStore.stepOne.hideSerialNumberErrorAlert = true
}


watch(stepOne, () => {
  stepOne.value.validStep = globalStore.areAllProductsValid() && productsLength.value > 0 && filesLength.value > 0
}, { deep: true })

onMounted(() => {
  addNewProductInfo(true)
})

</script>

<template>
  <CustomAlert :show="!isHiddenSerialNumberErrorAlert" :message="$t('stepOne.serialNumberValidationError')" @close="closeAlert" />
  <div ref="stepOne" class="form-view--step">
    <div class="form-view--step-header">
      <h2>{{ $t('stepOne.title') }}</h2>
      <span>{{ $t('stepOne.description') }}</span>
    </div>
    <div class="form-view--step-content">
      <div class="step-one-products" v-for="(product, index) in products" :key="product.id">
        <ProductInfo @delete="handleProductInfoDelete(product.id)" :index="index + 1" :id="product.id" :dealers="dealerNames" />
      </div>
      <div class="step-one--add-product-action">
        <div v-if="productsLength && productsLength <= maxCount" class="-btn -btn-eta" @click="addNewProductInfo(false)">
          <span>{{ $t('stepOne.addProduct') }}</span>
        </div>
      </div>
      <InvoiceUpload />
    </div>
  </div>
</template>

